// Copyright(c) 2024 RICOH Company, Ltd. All rights reserved.

'use strict'
import store from '@/store'
import AWSUtil from '../class/AWSUtil'
import Robots from '../class/Robots'
import Routes from '../class/Routes'

export class Schedules {
  apiUrl = ""

  constructor() {
    this.apiUrl = store.state.apiUrl
  }

  async getRobotList() {
    return await Robots.getManagedRobotList()
  }

  async getRouteList() {
    return await Routes.getRouteList()
  }

  getUserId() {
    let clientId = sessionStorage.getItem('clientId')
    return sessionStorage.getItem(`CognitoIdentityServiceProvider.${clientId}.LastAuthUser`)
  }

  async getSchedules(selectedRobotList, selectListFromDate, selectListToDate) {
    const axios = require('axios')
    let tenantId = sessionStorage.getItem('tenantId')
    const url = this.apiUrl + `/tenants/${tenantId}/schedules`
    
    // ヘッダーの署名を取得する
    let signedHeaderInfo = await AWSUtil.createSigV4(url, 'get')

    let startDateRequest = new Date(selectListFromDate).getTime() / 1000
    let endDateRequest = new Date(selectListToDate).getTime() / 1000
    console.log('getSchedules: robot lists=' + selectedRobotList + ' from date=' + selectListFromDate + '(' + startDateRequest + ') , to date=' + selectListToDate + '(' + endDateRequest + ')')
    
        
    // 認可情報と署名したヘッダーを利用してAPIをコールする
    return axios.get(url, {
      headers: {
        'Authorization': signedHeaderInfo.Authorization,
        'X-Host-Override': signedHeaderInfo.Host,
        'X-Amz-Date': signedHeaderInfo['X-Amz-Date'],
        'X-Amz-Security-Token': signedHeaderInfo['x-amz-security-token'],
        'Robot-IDs': selectedRobotList,
        'Start-Date': startDateRequest,
        'End-Date': endDateRequest
      }
    })
    .then((res) => {
      console.log('get schedules:')
      console.log(res.data)
      return res.data;
    })
    .catch((e) => {
      console.log(e);
    });
  }

  async registerSchedule(routeId, robotId, startDate, endDate, expectedWorktime, userId, recurringType, isSelectedStartingFromChargingStation, isSelectedReturningToChargingStation) {
    const axios = require('axios')
    let tenantId = sessionStorage.getItem('tenantId')
    let data = {
      routeId: routeId,
      robotId: robotId,
      startDate: startDate,
      endDate: endDate,
      expectedWorktime: expectedWorktime,
      userId: userId,
      recurringType: recurringType,
      doesStartFromChargingStation: isSelectedStartingFromChargingStation === false ?  0 : 1,
      doesReturnToChargingStation: isSelectedReturningToChargingStation === false ? 0 : 1
    }

    const url = this.apiUrl + `/tenants/${tenantId}/schedules`

    console.log('registerSchedule: robot id=' + robotId + ' route id=' + routeId + ' start date=' + startDate + ' , end date=' + endDate)

    // ヘッダーの署名を取得する
    let signedHeaderInfo = await AWSUtil.createSigV4(url, 'post', data)
        
    // 認可情報と署名したヘッダーを利用してAPIをコールする
    return axios.post(url, JSON.stringify(data), {
        headers: {
          'Authorization': signedHeaderInfo.Authorization,
          'X-Host-Override': signedHeaderInfo.Host,
          'X-Amz-Date': signedHeaderInfo['X-Amz-Date'],
          'X-Amz-Security-Token': signedHeaderInfo['x-amz-security-token'],
        },
      })
      .then((res) =>res.data)
      .catch((e) => {
        console.log(e);
      });
  }
  async editSchedule(scheduleId, userId, routeId, robotId, startDate, endDate, recurringType, isSelectedStartingFromChargingStation, isSelectedReturningToChargingStation, expectedWorktime) {
    const axios = require('axios')
    let tenantId = sessionStorage.getItem('tenantId')
    let data = {
      userId: userId,
      routeId: routeId,
      robotId: robotId,
      startDate: startDate,
      endDate: endDate,
      recurringType: recurringType,
      doesStartFromChargingStation: isSelectedStartingFromChargingStation === false ? 0 : 1,
      doesReturnToChargingStation: isSelectedReturningToChargingStation === false ? 0 : 1,
      expectedWorktime: expectedWorktime
    }

    const url = this.apiUrl + `/tenants/${tenantId}/schedules/${scheduleId}`

    console.log('editSchedule: schedule id=' + scheduleId + ' robot id=' + robotId + ' route id=' + routeId + ' user id=' + userId + ' start date=' + startDate + ' , end date=' + endDate)
    console.log('editSchedule: request body:' + JSON.stringify(data))

    // ヘッダーの署名を取得する
    let signedHeaderInfo = await AWSUtil.createSigV4(url, 'put', data)
      
    // 認可情報と署名したヘッダーを利用してAPIをコールする
    return axios.put(url, JSON.stringify(data), {
      headers: {
        'Authorization': signedHeaderInfo.Authorization,
        'X-Host-Override': signedHeaderInfo.Host,
        'X-Amz-Date': signedHeaderInfo['X-Amz-Date'],
        'X-Amz-Security-Token': signedHeaderInfo['x-amz-security-token'],
      },
    })
    .then((res) =>res.data)
    .catch((e) => {
      console.log(e);
    });
  }

  async deleteSchedule(scheduleId) {
    const axios = require('axios')
    let tenantId = sessionStorage.getItem('tenantId')
    const url = this.apiUrl + `/tenants/${tenantId}/schedules/${scheduleId}`

    console.log('deleteSchedule: schedule id=' + scheduleId)

    // ヘッダーの署名を取得する
    let signedHeaderInfo = await AWSUtil.createSigV4(url, 'delete')
      
    // 認可情報と署名したヘッダーを利用してAPIをコールする
    return axios.delete(url, {
      headers: {
        'Authorization': signedHeaderInfo.Authorization,
        'X-Host-Override': signedHeaderInfo.Host,
        'X-Amz-Date': signedHeaderInfo['X-Amz-Date'],
        'X-Amz-Security-Token': signedHeaderInfo['x-amz-security-token'],
      },
    })
    .then((res) =>res.data)
    .catch((e) => {
      console.log(e);
    });
  }
}
